import * as React from 'react';

const SmileEmojiIcon = ({fillColor = '#2D2756'}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.812 13.6666C16.812 15.4705 15.0076 17.3267 12.0001 17.3267C8.9926 17.3267 7.18799 15.4705 7.18799 13.6666"
      stroke={fillColor}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.71094 8.97662C9.71094 8.42662 9.26094 7.97662 8.71094 7.97662C8.16094 7.97662 7.71094 8.42662 7.71094 8.97662C7.71094 9.52662 8.16094 9.97662 8.71094 9.97662C9.26094 9.97662 9.71094 9.52662 9.71094 8.97662Z"
      fill={fillColor}
    />
    <path
      d="M16.7109 8.97662C16.7109 8.42662 16.2609 7.97662 15.7109 7.97662C15.1609 7.97662 14.7109 8.42662 14.7109 8.97662C14.7109 9.52662 15.1609 9.97662 15.7109 9.97662C16.2609 9.97662 16.7109 9.52662 16.7109 8.97662Z"
      fill={fillColor}
    />
  </svg>
);
export default SmileEmojiIcon;
